let observerDesktop;
let observerMobile;

function setFilterLocalStorage() {
  const storageDesktopKey = 'farbeClassNames';
  const storageMobileKey = 'farbeClassNamesMobile';

  if (!localStorage.getItem(storageDesktopKey)) {
    localStorage.setItem(storageDesktopKey, JSON.stringify([]));
  }

  if (!localStorage.getItem(storageMobileKey)) {
    localStorage.setItem(storageMobileKey, JSON.stringify([]));
  }
}

function activateObservers() {
  const config = { attributes: true, childList: true, subtree: true };
  const callback = function () {
    setTimeout(() => {
      updateFilterItems();
    }, 100);
  };
  const targetDesktop = document.querySelector('.active-facets.active-facets-desktop');
  const targetMobile = document.querySelector('.active-facets.active-facets-mobile');

  if (targetDesktop) {
    observerDesktop = new MutationObserver(callback);
    observerDesktop.observe(targetDesktop, config);
  }
  if (targetMobile) {
    observerMobile = new MutationObserver(callback);
    observerMobile.observe(targetMobile, config);
  }
}

function setCollectionDefaultFilterWhenNoFilterIsSet(writeToLocalStorage = true) {
  const storageDesktopKey = 'farbeClassNames';
  const storageMobileKey = 'farbeClassNamesMobile';
  const defaultColorElement = document.querySelector('[data-default-filter-color]');
  const defaultColor = defaultColorElement ? defaultColorElement.getAttribute('data-default-filter-color') : 'Gold';

  if (!defaultColor) {
    return { defaultColor: [], wasSet: false };
  }

  const defaultColorArray = [defaultColor];
  let isSet = false;

  const storedDesktopItems = JSON.parse(localStorage.getItem(storageDesktopKey)) || [];
  if (storedDesktopItems.length === 0 && writeToLocalStorage) {
    localStorage.setItem(storageDesktopKey, JSON.stringify(defaultColorArray));
    isSet = true;
  }

  const storedMobileItems = JSON.parse(localStorage.getItem(storageMobileKey)) || [];
  if (storedMobileItems.length === 0 && writeToLocalStorage) {
    localStorage.setItem(storageMobileKey, JSON.stringify(defaultColorArray));
    isSet = true;
  }
  return { defaultColor: defaultColorArray, wasSet: isSet };
}

function setFilterUrlsAndLocalStorage(writeToLocalStorage = true) {
  const filterSetResult = setCollectionDefaultFilterWhenNoFilterIsSet(writeToLocalStorage);
  if (filterSetResult.wasSet) {
    fetchSetFilteredProducts(filterSetResult.defaultColor);
  } else {
    const paramValueDesktop = JSON.parse(localStorage.getItem('farbeClassNames')) || [];
    const paramValueMobile = JSON.parse(localStorage.getItem('farbeClassNamesMobile')) || [];
    let paramValue;

    if (JSON.stringify(paramValueDesktop) !== JSON.stringify(paramValueMobile)) {
      paramValue = Array.from(new Set([...paramValueDesktop, ...paramValueMobile]));
    } else {
      paramValue = paramValueDesktop;
    }

    fetchSetFilteredProducts(paramValue);
  }
}

function fetchSetFilteredProducts(paramValue) {
  const currentUrl = new URL(window.location.href);
  const paramKey = 'filter.p.m.schmuko.color_list';

  if (paramValue.length > 0 && !currentUrl.searchParams.has(paramKey) && paramValue && !location.search) {
    currentUrl.searchParams.append(paramKey, paramValue);
    window.history.replaceState({}, '', currentUrl);
    deactivateObservers();
    fetch(currentUrl?.href)
      .then((r) => r.text())
      .then((data) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');
        document.querySelector('aside').innerHTML = '';
        document.querySelector('aside').insertAdjacentHTML('afterbegin', doc.querySelector('aside').innerHTML);
        document.querySelector('#ProductGridContainer').innerHTML = '';
        document
          .querySelector('#ProductGridContainer')
          .insertAdjacentHTML('afterbegin', doc.querySelector('#ProductGridContainer').innerHTML);
        activateObservers();
      });
    updateUrls(paramValue);
  }
}

function updateUrls(paramValue) {
  const links = document.querySelectorAll('a[href*="/collections/"]');
  const paramKey = 'filter.p.m.schmuko.color_list';
  links.forEach((link) => {
    const url = new URL(link.href);
    url.searchParams.delete(paramKey);
    paramValue.forEach((value) => {
      url.searchParams.append(paramKey, value);
    });
    link.href = url.toString();
  });
}

function updateUrlsFromLocalStorage() {
  const storageDesktopKey = 'farbeClassNames';
  const storageMobileKey = 'farbeClassNamesMobile';

  const paramValueDesktop = JSON.parse(localStorage.getItem(storageDesktopKey)) || [];
  const paramValueMobile = JSON.parse(localStorage.getItem(storageMobileKey)) || [];
  let paramValue;

  if (JSON.stringify(paramValueDesktop) !== JSON.stringify(paramValueMobile)) {
    paramValue = Array.from(new Set([...paramValueDesktop, ...paramValueMobile]));
  } else {
    paramValue = paramValueDesktop;
  }

  updateUrls(paramValue);
}

function deactivateObservers() {
  if (observerDesktop) observerDesktop.disconnect();
  if (observerMobile) observerMobile.disconnect();
}

function updateFilterItems() {
  deactivateObservers();

  const checkedInputs = document.querySelectorAll(
    '.active-facets .farbe-wrapper > .parent-display .list-menu__item.facets__item input:checked'
  );

  let selectedItems = [...checkedInputs].map((el) => el.value);
  selectedItems = Array.from(new Set(selectedItems));

  localStorage.setItem('farbeClassNames', JSON.stringify(selectedItems));
  localStorage.setItem('farbeClassNamesMobile', JSON.stringify(selectedItems));

  if (selectedItems.length === 0) {
    const defaultColorElement = document.querySelector('[data-default-filter-color]');
    const defaultColor = defaultColorElement ? defaultColorElement.getAttribute('data-default-filter-color') : 'Gold';
    const defaultColorArray = [defaultColor];

    localStorage.setItem('farbeClassNames', JSON.stringify(defaultColorArray));
    localStorage.setItem('farbeClassNamesMobile', JSON.stringify(defaultColorArray));

    const defaultInput = document.querySelector(`input[name="filter.p.m.schmuko.color_list"][value="${defaultColor}"]`);
    if (defaultInput) {
      defaultInput.click();
    }

    setFilterUrlsAndLocalStorage(false);
    updateUrls(defaultColorArray);
  } else {
    setFilterUrlsAndLocalStorage();
  }

  updateUrls(selectedItems);
  activateObservers();
}

/*
/ LUA-185 - Add urgency nudging for returning users sitewide + cart
*/

const messagePopup = document.querySelector('.LUA-185__pop-up-message');

function setInteractedClass() {
  if (sessionStorage.getItem('LUA-185__interacted')) {
    document.body.classList.add('LUA-185__interacted');
  }
}

function setRedDot() {
  const redDotTop = document.getElementById('top-circle');
  const redDotBottom = document.getElementById('bottom-circle');
  if (
    (redDotTop && redDotBottom && sessionStorage.getItem('LUA-185__tagged-product')) ||
    (redDotTop && redDotBottom && document.querySelector('.LUA-185__tag:not(.hidden)'))
  ) {
    redDotTop.classList.remove('hidden');
    redDotBottom.classList.remove('hidden');
  }
}

function setTagAndMessage() {
  let selected_product;

  const sessionStorageItem = sessionStorage.getItem('LUA-185__tagged-product');

  if (sessionStorageItem && sessionStorageItem !== 'null') {
    const productAnchor = document.querySelector(`.cart-item .cart-item__media a[href*="${sessionStorageItem}"]`);
    if (productAnchor) {
      selected_product = productAnchor.closest('.cart-item');
    }
  } else {
    const selected_productElement = document.querySelector('cart-drawer-items');
    if (selected_productElement) {
      const productAnchor = document.querySelector(
        `.cart-item .cart-item__media a[href*="${selected_productElement.getAttribute('data-itemUrl')}"]`
      );
      if (productAnchor) selected_product = productAnchor.closest('.cart-item');
    }
  }

  if (selected_product) {
    const selected_product_tag = selected_product.querySelector('.LUA-185__tag');
    selected_product_tag.classList.remove('hidden');

    const selected_product_image_url = selected_product.querySelector('.cart-item__media img').src;
    const messagePopupImage = messagePopup.querySelector('img');
    messagePopupImage.src = selected_product_image_url;
    setTimeout(function () {
      messagePopup.classList.remove('hidden');
    }, 1000);
  }
}

function setSessionStorage() {
  document.body.classList.add('LUA-185__interacted');
  sessionStorage.setItem('LUA-185__interacted', true);
  const selected_productElement = document.querySelector('cart-drawer-items');
  sessionStorage.setItem('LUA-185__tagged-product', selected_productElement.getAttribute('data-itemUrl'));
}

function setSessionStorageOnLoad() {
  sessionStorage.removeItem('LUA-185__tagged-product');
  const selected_productElement = document.querySelector('cart-drawer-items');

  if (selected_productElement.getAttribute('data-itemUrl')) {
    const selected_product_url = selected_productElement.getAttribute('data-itemUrl');
    sessionStorage.setItem('LUA-185__tagged-product', selected_product_url);
  }
}

function clickListener() {
  window.addEventListener('scroll', () => {
    setSessionStorage();
  });
}

function scrollListener() {
  window.addEventListener('click', () => {
    setSessionStorage();
  });
}

function changeListener() {
  window.addEventListener('cartFetchEvent', function () {
    main();
  });
}

function main() {
  setTagAndMessage();
  setRedDot();
}

function init185() {
  setInteractedClass();
  setSessionStorageOnLoad();
  main();
  clickListener();
  scrollListener();
  changeListener();
}

/*
/ Wishlist Add to Cart
*/

function preventDefaultWishlistAtc() {
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form.iwish-product-form');
    if (form) {
      e.preventDefault();

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json',
        },
      })
        .then((response) => {
          if (!response.ok) throw new Error('Fehler beim Hinzufügen');
          return response.json();
        })
        .then((data) => {
          console.log('Zum Warenkorb hinzugefügt:', data);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch((error) => {
          console.error('Fehler:', error);
        });
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  setFilterLocalStorage();
  if (window.location.pathname.includes('/collections/')) {
    setFilterUrlsAndLocalStorage(true);
    activateObservers();
  } else {
    updateUrlsFromLocalStorage();
  }
  if (window.location.pathname.includes('/iwish')) {
    preventDefaultWishlistAtc();
  }
  init185();
});
